import { createContext, useState } from "react";
import getCountyLimits from "../util/countyLimits2024";

export const CountyLimitsContext = createContext({
  countyLimits: null,
  isLoading: false,
  fetchCountyLimits: () => {},
});

export function CountyLimitsProvider({ children }) {
  const [countyLimits, setCountyLimits] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCountyLimits = async () => {
    if (countyLimits) return;
    try {
      setIsLoading(true);
      const countyLimits = await getCountyLimits();
      setCountyLimits(countyLimits);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CountyLimitsContext.Provider
      value={{ countyLimits, isLoading, fetchCountyLimits }}
    >
      {children}
    </CountyLimitsContext.Provider>
  );
}
